import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// MUI
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";

// Custom Components
import { GridContainer } from "@/ui/Grid";
import FormButton from "@/ui/Form/FormButton";
import FormContent from "@/components/FormContent";
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";
import useAuthFormController from "@/components/useAuthFormController";

// Types
import { PasswordResetFormProps } from "@/@types/views/Auth";

function PasswordResetForm(props: PasswordResetFormProps) {
  const { t } = useTranslation();
  const snackbarContext = useContext(SnackbarContext);

  const navigate = useNavigate();

  const { record, fields, validation, onFieldChange, doResetPassword } = useAuthFormController(props);

  const handleFieldChange = (value: any, source: string) => {
    if (onFieldChange) {
      onFieldChange(value, source);
    }
  };

  const handleSubmit = () => {
    if (doResetPassword) {
      doResetPassword()
        .then((result) => {
          if (result) {
            if (result.success) {
              if (snackbarContext) {
                snackbarContext.showNotification(t("users.password_set"), "success");
              }
              navigate("/login");
            }
          }
        })
        .catch((result) => {
          if (result.validationPass === false) {
            // console.log(result.validation);
          } else if (snackbarContext) {
            snackbarContext.showNotification(result.error as string, "error");
          }
        });
    }
  };

  return (
    <Card>
      <CardHeader
        title={t("titles.password_reset")}
        />
      <CardContent>
        <GridContainer>
          <FormContent
            fieldNames={["email", "passwordreset_token", "password_new", "password_new_confirm"]}
            record={record}
            fields={fields}
            mode="insert"
            columns={1}
            validation={validation}
            onFieldChange={handleFieldChange}
            onSubmit={handleSubmit}
          />
        </GridContainer>
      </CardContent>
      <CardActions sx={{flexDirection: {xs: "column", md: "row"}, rowGap: 1}}>
        <FormButton color="primary" variant="contained" onClick={handleSubmit} sx={{mx: 1, width: {xs: "100%", md: "auto"}}}>
          {t("buttons.confirm")}
        </FormButton>
      </CardActions>
    </Card>
  );
}

export default PasswordResetForm;
